import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { NamedWizard } from '@/components/wizard'
import media from '@/media'
import { colors, structure } from '@/styles'
import { toUnit } from '@/utils/styles'
import DirectDepositWizardForm from './direct-deposit-form'

const WizardWrapper = styled.div`
  top: ${toUnit(structure.header.height)};
  background: ${colors.white};
  position: sticky;
  width: 100%;
  z-index: 2;
  border-bottom: 1px solid ${colors.mediumLightGrey};

  ${media.lessThan('ipadMiniMax')`
    top: ${toUnit(structure.header.heightMobile)};
  `}
`

const StyledNamedWizard = styled(NamedWizard)`
  margin: 0 auto;
  max-width: 720px;
  background: transparent;
  border-bottom: none;
`

const AddDirectDeposit = ({ history }) => {
  const { t } = useTranslation()
  const [currentStep, setCurrentStep] = useState('personal_info')

  const WIZARD_STEPS = {
    personal_info: t('b.payment_settings.edit.general_information.text', 'General Information'),
    financial_info: t(
      'b.payment_settings.edit.financial_information.text',
      'Financial Information'
    ),
    review: t('b.payment_settings.edit.review_terms.text', 'Review Terms')
  }

  const handleBack = () => {
    if (currentStep === 'financial_info') {
      setCurrentStep('personal_info')
    } else if (currentStep === 'review') {
      setCurrentStep('financial_info')
    } else {
      history.push('/settings/payment-settings/direct-deposit')
    }
    window.scrollTo(0, 0)
  }

  const onSuccess = () => {
    history.push('/settings/payment-settings/direct-deposit')
  }

  return (
    <>
      <Helmet>
        <title>{t('l.payment_settings.view.direct_deposit.title', 'Direct Deposit')}</title>
      </Helmet>
      <WizardWrapper>
        <StyledNamedWizard steps={WIZARD_STEPS} currentStep={currentStep} />
      </WizardWrapper>
      <DirectDepositWizardForm
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        handleBack={handleBack}
        onSuccess={onSuccess}
      />
    </>
  )
}

export default AddDirectDeposit
